<template>
  <div class="lean-create-linked-document-dialog">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon @click="openDialog">mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('create.create') }}</span>
    </v-tooltip>
    <v-dialog v-model="showDialog" :width="getDialogSize" scrollable>
      <v-card class="lean-create-linked-document-dialog__card">
        <v-toolbar color="blue-grey darken-1" dark flat>
          <v-spacer />
          <v-toolbar-title>{{ `${$t('create.create')} (${title})` }}</v-toolbar-title>
          <v-spacer />
          <v-btn icon @click="showDialog = false"><v-icon>mdi-close </v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="pa-0">
          <LeanForm
            v-if="record && showDialog"
            :record="record"
            :loading="loading"
            :datatype="datatype"
            existingSlug=""
            :showToolbar="false"
            @saved="reload($event)"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { v4 as uuid } from 'uuid';

export default {
  // this is a recursive component use, so that you need a speical import for this
  components: { LeanForm: () => import('./LeanForm.vue') },
  name: 'LeanCreateLinkedDocumentDialog',
  props: {
    datatype: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showDialog: false,
      loading: true,
      record: null
    };
  },
  computed: {
    ...mapState({
      models: 'models'
    }),
    title() {
      switch (this.$i18n.locale) {
        case 'en':
          return this.models[this.datatype].title.en_US;
        default:
          return this.models[this.datatype].title.de_DE;
      }
    },
    getDialogSize() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return this.$vuetify.breakpoint.width / 2;
      }
      return this.$vuetify.breakpoint.width;
    },
    uuid() {
      return uuid();
    }
  },
  methods: {
    openDialog() {
      this.showDialog = true;
      this.loading = true;
      this.record = {};
      this.models[this.datatype].schema.map((field) => {
        this.record[field.name] = null;
      });
      this.loading = false;
    },
    reload(slug) {
      this.$emit('afterSave', slug);
      this.showDialog = false;
    }
  }
};
</script>

<style lang="scss">
.lean-create-linked-document-dialog__card {
  .lean-form-btn-save {
    position: absolute;
  }
  .lean-form {
    overflow-y: auto;
    .v-card {
      border: 0;
    }
  }
}
</style>
